import { BrowserRouter, Route, Routes} from 'react-router-dom';
import NavBar from './components/NavBar/NavBar';
import HomePage from './pages/HomePage';
import LoggedOutView from "./components/LoggedOutView";
import ProductsPage from './pages/ProductsPage';
import CartPage from './pages/CartPage';
import Group1Page from './pages/Group1Page';
import NotFoundPage from './pages/NotFoundPage';
import { ShopContextProvider } from './context/ShopContext';
import { User } from './models/user';
import { useEffect, useState } from 'react';
import * as UserApi from "./network/user_api";
import { GetGroup1Data, GetGroup2Data } from './hooks/GetProductCategories';
import { Group1Schema } from './models/Group1Items';
import { Group2Schema } from './models/Group2Items';
import AdminPage from './pages/AdminPage';
import { Container, Spinner } from 'react-bootstrap';

function App() {

    const [loggedInUser, setLoggedInUser] = useState<User | null>(null);
    const [group1, setGroup1] = useState<Group1Schema[]>([]);
    const [group2, setGroup2] = useState<Group2Schema[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [groupsLoading, setGroupsLoading] = useState<boolean>(false);

    useEffect(() => {
        async function fetchLoggedInUser() {
            try {
                const user = await UserApi.getLoggedInUser();
                setLoggedInUser(user);
            } catch (error) {
                return;
            } finally {
                setLoading(false);
            }
        }
        fetchLoggedInUser();
    }, []);
    
    useEffect (() => {
        if (loggedInUser) {
            const fetchGroups = async () => {
                setGroupsLoading(true);
                const group1Data = await GetGroup1Data();
                const group2Data = await GetGroup2Data();
                setGroup1(group1Data);
                setGroup2(group2Data);
                setGroupsLoading(false);
            }
            fetchGroups();
        }
    }, [loggedInUser]);

    return (

        <BrowserRouter>
            <ShopContextProvider>
                <NavBar
                    loggedInUser={loggedInUser}
                    onLogoutSuccessful={() => setLoggedInUser(null)}
                    group1={group1}
                    group2={group2}
                />
                <Routes>
                    <Route
                        path="/g2/:category"
                        element={<ProductsPage loggedInUser={loggedInUser} group1={group1} group2={group2} />}
                    />
                    <Route
                        path="/g1/:category"
                        element={<Group1Page loggedInUser={loggedInUser} group1={group1} group2={group2} />}
                    />
                    <Route 
                        path='/'
                        element={<HomePage loggedInUser={loggedInUser} group1={group1} />}
                    />
                    <Route
                        path='/cart'
                        element={<CartPage loggedInUser={loggedInUser} />}
                    />
                    <Route
                        path='/admin'
                        element={<AdminPage loggedInUser={loggedInUser} />}
                    />
                    <Route
                        path='/*'
                        element={<NotFoundPage/>}
                    />
                </Routes>
            </ShopContextProvider>

            {!loggedInUser && !loading &&
                <LoggedOutView
                    onLoginSuccessful={(user) => {
                        setLoggedInUser(user);
                    }}
                />
            }

            {((!loggedInUser && loading) || groupsLoading) && 
                <Container className="d-flex align-items-center justify-content-center">
                    <Spinner className="LoadingSpinner" animation="border" role="status" variant="secondary">
                        <span className="visually-hidden">Περιμένετε λίγο...</span>
                    </Spinner>
                </Container>
            }
        </BrowserRouter>
    );
}

export default App;